// The reject history's window vocabulary: the selectable lookback windows and
// the one way to name any of them. Both the summary card and the panel below it
// state the window in prose, and before this they each carried their own copy of
// the same lookup — two places to change a label, and two chances to disagree
// about what "6h" means on a page whose whole job is to be trusted.

export const REJECT_WINDOWS: { label: string; ms: number }[] = [
  { label: '1h', ms: 3_600_000 },
  { label: '6h', ms: 6 * 3_600_000 },
  { label: '24h', ms: 24 * 3_600_000 },
  { label: '3d', ms: 3 * 24 * 3_600_000 },
];

/** Names a window. Falls back to whole hours so a windowMs the buttons don't
 *  offer — an old link, a hand-edited URL — still reads as a duration rather
 *  than as a bare millisecond count. */
export function windowLabel(ms: number): string {
  return REJECT_WINDOWS.find((w) => w.ms === ms)?.label ?? `${Math.round(ms / 3_600_000)}h`;
}
